import axios from "axios";

import { webUrlNode } from "../../../constants/appInfo";

export async function getRoles(AppToken) {

  const res = await axios.get(`${webUrlNode}/api/roles?appToken=${AppToken}`, {
    
  });
  return res.data;
}
export async function createRole(data) {
  const res = await axios.post(`${webUrlNode}/api/roles?appToken=${data?.AppToken}`, data);
  return res.data;
}
export async function getRolePermissions(roleId,AppToken) {
  const res = await axios.get(`${webUrlNode}/api/rolesPermissions/${roleId}/permissions?appToken=${AppToken}`);
  return res.data;
}

export async function replaceRolePermissions(roleId, permissions,AppToken) {
  const res = await axios.put(
    `${webUrlNode}/api/rolesPermissions/${roleId}/replace?appToken=${AppToken}`,
    { permissions }
  );
  return res.data;
}


export async function getRolesBatches(AppToken) {
  const res = await axios.get(`${webUrlNode}/api/roles/batches?appToken=${AppToken}`, {
   
  });
  return res.data;
}

export async function getUserRoles(userId,AppToken) {
  const res = await axios.get(`${webUrlNode}/api/roles/user/${userId}?appToken=${AppToken}`, {
   
  });
  return res.data;
}

export async function getAppUsersWithRoles(AppToken) {
  const res = await axios.get(`${webUrlNode}/api/roles/app-users?appToken=${AppToken}`, {
    
  });
  return res.data;
}
export async function assignRole(data) {
  const res = await axios.post(`${webUrlNode}/api/roles/assign?appToken=${data?.appToken}`, data);
  return res.data;
}

export async function changeRole(data) {
  const res = await axios.put(`${webUrlNode}/api/roles/change?appToken=${data?.AppToken}`, data);
  return res.data;
}

export async function removeRole(data) {
  const res = await axios.delete(`${webUrlNode}/api/roles/remove?appToken=${data?.AppToken}`, {
    data
  });
  return res.data;
}